


import PropTypes from 'prop-types';
import useTranslations from "../providers/useTranslations";
import { uuidv4, formatPrice } from '../lib/utils'

import { CartContext } from '../providers/CartContext';
import CheckoutItem from './components/common/CheckoutItem'

const CartView = (props) => {

  const { closeCart,
    selectedMenu,
    setStage
  } = props;

  const { cartItems, addItemToCart, clearCart, setItemQuantity, removeItem, pendingOrder, totalItemsCost } = React.useContext(CartContext);

  const { tr /* , getTranslations, locale, translations, setLocale */ } = useTranslations();

  React.useEffect(() => {


  }, [selectedMenu, cartItems]);


  const titleElement = () => {

    let fsize = 40

    return (
      <h3 className="mt-3 py-2 col-md-12 category-header">
        <div >

          <span className="category-expander" onClick={() => closeCart()} style={{
            marginRight: 40
          }}>
            <i className="fa fa-chevron-left fa-2x" aria-hidden="true" style={{ color: '#222' }}></i>
          </span>

          <span style={{
            fontSize: fsize
          }}>
            {tr("Cart")} <br />

          </span>

        </div>

      </h3>
    )
  }

  //console.log("category", category.name, category.Categories, category.Products)

  return (<div id="cartview" className="px-1" >

    {titleElement()}


    <div className ="col-md-12" style={{
      padding: 4
    }}>

      <div className=" "

        style={{ color: 'black' }}>


        <div className="bg-white   mb-2" style={{    }}>
          {cartItems.map((item, index) => {
            return <CheckoutItem
              key={'cart_item_' + index}
              itemName={item.name}
              image={item.photo}
              cartItem={item}
              price={item.chosenPrice || item.price}
              priceUnit="$"
              id={item.id}
              quantity={item.quantity}
              show={true}
              minValue={0}
              maxValue={7}
              setValue={(args) => {
                console.log("checkout item", args);
                if (args.quantity === 0) {
                  removeItem(item, args);
                } else {
                  setItemQuantity(item, args.quantity);
                }
              }}
              formatPrice={formatPrice}
            />
          }
          )}

        </div>
        <div className="mb-2 bg-white rounded p-2 clearfix">
          <img fluid="true" className="float-left" src="/img/wallet-icon.png" />
          <h6 className="font-weight-bold text-right mb-2">{tr('Subtotal')} : <span className="text-danger">{formatPrice(totalItemsCost())}</span></h6>
          <p className="seven-color mb-1 text-right">{tr("Extra charges may apply")}</p>
          {/* <p className="text-black mb-0 text-right hidden">You have saved $955 on the bill</p> */}
        </div>
        <div className="btn btn-success btn-block btn-lg"
          onClick={() => setStage("checkout")}
        >{tr('Next')}
          <i className="icofont-long-arrow-right" /></div>
        {/*  <div className="pt-2"></div>

                  <div className="pt-2"></div> */}
      </div>



    </div>

  </div>)
}

export default CartView

